import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { toast } from 'react-toastify'

import { getPlantingFailureSummaryFromDiagnosis } from '@/services/get-planting-failure-summary-from-diagnosis'

export const GET_PLANTING_FAILURE_SUMMARY_FROM_DIAGNOSIS_QUERY =
  'GET_PLANTING_FAILURE_SUMMARY_FROM_DIAGNOSIS_QUERY'

export function useGetPlantingFailureSummaryFromDiagnosis(
  culture: string,
  diagnosisId: string,
  enabled: boolean,
) {
  const queryKey = useMemo(
    () => [
      GET_PLANTING_FAILURE_SUMMARY_FROM_DIAGNOSIS_QUERY,
      culture,
      diagnosisId,
    ],
    [culture, diagnosisId],
  )

  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) =>
      getPlantingFailureSummaryFromDiagnosis(culture, diagnosisId, { signal }),
    enabled,
    cacheTime: 0,
    onError(e: any) {
      toast.error(
        'Ocorreu um erro ao buscar o resumo de falha de plantio: ' + e.message,
      )
    },
  })
  return query
}
